import React, { Component } from 'react'
import image from '../../mouseimages/5-7.jpg'
import '../stylesheets/sixbuttondesign.css'
export default class Sixbuttondesign extends Component {
    render() {
        return (
            <div className="sixbutton-container">
             <section className ="sixbutton-content">
                   <h3> 
                    <p>According To</p>
                    <p>Your Ease</p>
                    <p>Configure it!!</p>
                    </h3>
                </section>
                <img src={image} alt="sixbuttondesign"></img>
               
            </div>
        )
    }
}
